import { prepareAuthor } from './prepareAuthor';
import { prepareFeatures } from './prepareFeatures';
import { prepareGeo } from './prepareGeo';
import { prepareImageUrl } from './prepareImageUrl';
import { prepareOfferUrl } from './prepareOfferUrl';
import { IOfferForMobileSiteSchema } from 'shared/repositories/search-engine/entities/offer/OfferForMobileSiteSchema';
import { TOffer } from 'shared/types/offer';
import { preparePrice } from './preparePrice';
import { prepareLabels } from './prepareLabels';
import { IConfigUnsafe } from '@cian/config/shared';

export const prepareOffer = (offer: IOfferForMobileSiteSchema, config: IConfigUnsafe): TOffer => {
  const { building, cianId, dealType, gaLabel, id, offerType } = offer;

  return {
    author: prepareAuthor(offer.author),
    building,
    cianId,
    dealType,
    gaLabel,
    id,
    imageUrl: prepareImageUrl(offer.media),
    offerType,
    labels: prepareLabels(offer, config),
    price: preparePrice(offer),
    features: prepareFeatures(offer.features),
    geo: prepareGeo(offer.geo),
    href: prepareOfferUrl(offer),
  };
};
